import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import VisorPDF from "@Utilitarios/VisorPDF/VisorPDF";
import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import MEliminarProductoTerminado from "@Productos/Modales/MEliminarProductoTerminado";
import MAgregarEditarProductoTerminado from "@Productos/Modales/MAgregarEditarProductoTerminado";
import MDetalleProductoTerminado from "@Productos/Modales/MDetalleProductoTerminado";


import * as _testing_ from "@Funciones/testing";
import "./ProductosTerminados.css";

function ProductosTerminados() {
  const origenComponente = "ProductosTerminados";
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    v_formulario: false,
    v_modal: false,
    i_procesandoApiCarga: true,
    do_datosTabla: {},
    do_filtros: {},
    do_seleccionados: {},
    da_distribuidores: [],
    d_usuario: "",
    d_editarVarios: false,
    d_eliminarVarios: false,
    d_agregarPT: false,
  });

  useEffect(() => {
    console.log("usuario", v_u.d_usuario);
    const productosTerminadosCrud = _api_.f_productosTerminadosCRUD({
      parametros: {
        modo: "DSG",
        codUsuario: v_u.d_usuario,
        codigoProducto: "",
        codigosProductos: [],
        todo: "S"
      },
      timeout: 5000,
    });
    productosTerminadosCrud.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        _f_.asignar(ev_u, { do_datosTabla: dPC.contenido });
        console.log(dPC.contenido);
      }
      _f_.asignar(ev_u, { i_procesandoApiCarga: false });
    });
  }, [v_u.d_usuario,recargaComponente]);

  useEffect(() => {
    const distribuidores = _api_.f_listaDistribuidores({
      timeout: 5000,
    });
    distribuidores.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        //console.log(dPC.contenido);
        _f_.asignar(ev_u, { da_distribuidores: dPC.contenido.Distribuidores });
      }
    });
  }, []);

  useEffect(() => {
    //console.log(v_u.do_filtros);
    //console.log(v_u);
    //console.log(v_u.do_seleccionados);
    //console.log(cv_u);
  }, [v_u.do_filtros, cv_u]);

  if (v_u.i_procesandoApiCarga) return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;

  //if (cv_u.error) return <div>error</div>;

  return (
    <div className="productosTerminados-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false, errores_mostrar: false, errores_lista: [] });
          }}>
          {v_c.errores_mostrar && <_lul_.ListaUL listaElementos={v_c.errores_lista} />}
          {!v_c.errores_mostrar && (v_u.d_editarVarios || v_u.d_agregarPT) && (
            <MAgregarEditarProductoTerminado
              datosComplementarios={{ codDistribuidor: v_u.d_usuario, productosSeleccionados: v_u.do_seleccionados }}
              origenComponente={origenComponente}
              registro={{
                codigo: 0,
                modoVista: v_u.d_agregarPT ? "INSU" : "EDITV",
              }}
              fCerrarComponente={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
              fActualizarTablaTotal={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
            />
          )}
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Productos Terminados"}</div>
      <div style={{ padding: "0.3rem", width: "100%" }}>
        <_opt_.Opcion2
          texto="Distribuidor"
          clave={["codUsuario"]}
          valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
          opciones={v_u.da_distribuidores || []}
          name={"wefwfwefwef"}
          estilos={{ flexGrow: 1, width: "100%" }}
          onBlur={(evento) => {
            _f_.asignar(ev_u, {
              d_usuario: evento.target.getAttribute("value"),
            });
            console.log(evento.target.getAttribute("value"));
          }}
        />
      </div>
      {
        <Filtros
          filtros={v_u.do_datosTabla.filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtros: valores });
          }}
        />
      }

      <div className="productosTerminados-cuerpo">
        <_tabla_.Tabla
          origenComponente={origenComponente}
          modoVista={"modo2"}
          cabecera={v_u.do_datosTabla.headgrid}
          registros={v_u.do_datosTabla.grid}
          filtros={v_u.do_filtros}
          datosComplementarios={{ codDistribuidor: v_u.d_usuario, productosSeleccionados: v_u.do_seleccionados }}
          permiteVerCategoriaCompleta={true}
          permiteMultiseleccion={true}
          permiteOpciones={true}
          opcionesPorDefecto={0b00_000_011}
          camposCodigosSeleccion={["codigo"]}
          campoCodigoCategoria={"categoria"}
          reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
          permiteDespliegueInferiorPorRegistro={false}
          permiteDespliegueModalPorRegistro = {true}
          permiteDetalleAlTocarElemento={true}
          mapaDeComponentes={{
            MEliminarProductoTerminado,
            MDetalleProductoTerminado,
            MAgregarEditarProductoTerminado,
          }}
          fObtenerSeleccionados={(seleccionados) => {
            _f_.asignar(ev_u, { do_seleccionados: seleccionados });
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
             
              erecargaComponente((prev) => !prev);
            }
          }}
        />
      </div>

      <div className="productosTerminados-opciones">
        {v_u.d_usuario == "" && (
          <_btn_.Boton
            texto="Agregar Producto Terminado"
            tipo="btn-2"
            estilos={{ color: "#4e942e", anchoB2: "10rem" }}
            onClick={() => {
              _f_.asignar(ev_c, { modal_mostrar: true, modal_titulo: "Agregar Producto Terminado", modal_estilos:{anchoMI:"40rem"} });
              _f_.asignar(ev_u, { d_editarVarios: false, d_eliminarVarios: false, d_agregarPT: true });
            }}
          />
        )}
        <_btn_.Boton
          texto="Editar Varios"
          tipo="btn-2"
          estilos={{ color: "var(--color_amarillo_1)", anchoB2: "10rem", colorFuenteB2: "black" }}
          onClick={() => {
            let errores = [];
            if (Object.values(v_u.do_seleccionados).map((item) => item.codigo).length == 0) {
              errores.push("Es necesario seleccionar al menos un registro");
              _f_.asignar(ev_c, {
                modal_mostrar: true,
                modal_titulo: "Error el Editar Varios",
                errores_mostrar: true,
                errores_lista: errores,
              });
            } else {
              _f_.asignar(ev_c, {
                modal_mostrar: true,
                modal_titulo: "Editar Varios",
                modal_estilos: { anchoMI: "40rem" },
              });
              _f_.asignar(ev_u, { d_editarVarios: true, d_eliminarVarios: false, d_agregarPT: false });
            }
          }}
        />
        {v_u.d_usuario == "" && (
          <_btn_.Boton
            texto="Eliminar Varios"
            tipo="btn-2"
            estilos={{ color: "var(--color_rojo_1)", anchoB2: "10rem" }}
            onClick={() => {
              let errores = [];
              if (Object.values(v_u.do_seleccionados).map((item) => item.codigo).length == 0) {
                errores.push("Es necesario seleccionar al menos un registro");
                _f_.asignar(ev_c, {
                  modal_mostrar: true,
                  modal_titulo: "Error el Eliminar Varios",
                  errores_mostrar: true,
                  errores_lista: errores,
                });
              } else {
                _f_.asignar(ev_c, { modal_mostrar: true, modal_titulo: "Eliminar Varios" });
                _f_.asignar(ev_u, { d_editarVarios: false, d_eliminarVarios: true, d_agregarPT: false });
              }
            }}
          />
        )}
      </div>
    </div>
  );
}
export default ProductosTerminados;
